import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bankersRound' })
export class BankersRoundPipe implements PipeTransform {
  constructor() {}

  transform(input: number, decimalPlaces = 2): number {
    const x = input * Math.pow(10, decimalPlaces);
    const r = Math.round(x);
    const br = Math.abs(x) % 1 === 0.5 ? (r % 2 === 0 ? r : r - 1) : r;
    return br / Math.pow(10, decimalPlaces);
  }
}
